import { RequiredCustomerWarning } from '~/purchase/components';
import { usePurchaseContext } from '~/purchase/context';

export default function PurchaseCustomerProtected({
  component: Component,
}: {
  component: React.ComponentType;
}) {
  const { state } = usePurchaseContext();

  if (state.targetCustomer?.purchaseSearchable) {
    return <Component />;
  }

  return <RequiredCustomerWarning />;
}
